module.exports = __webpack_public_path__ + "UX21.jpg?13ef0a0204276626da98acac03aa4a12";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX21.jpg
// module id = 71
// module chunks = 0